import React from "react";
import { connect } from "react-redux";

// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './outboundResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class OutboundResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getOutboundLogData = () => {

        let sortedArray = this.props.outboundLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];

        sortedArray.forEach((entry) => {
            JSX.push(<tr className="OutboundResult-value" key={entry.id}>
                <td className="OutboundResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>
                <td><a target='_blank' rel="noopener noreferrer" href={`/campaign/${entry.CampaignID}`}> {`${entry.CampaignID}`}</a></td>
                <td className="OutboundResult-recipient-value">{entry.RecipientEmailAddress}</td>

                <td><a target='_blank' rel="noopener noreferrer" href={`https://www.gmass.co/gmass/showmessage?tokenid=${entry.TokenID}&messageid=${entry.GmailResponse}`}>Show Message</a></td>

                <td>{entry.ThreadID}</td>
                <td className="OutboundResult-draft-value">{entry.JustDraft ? 'Yes': 'No'}</td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () =>{
        if(this.state.currentPage < this.props.maxPage ){
            this.setState({currentPage: this.state.currentPage+1})
        }
    }
    movePreviousPage = () =>{
        if(this.state.currentPage > 1){
            this.setState({currentPage:this.state.currentPage - 1})
        }
    }

    conditionalRendering = () => {
        if (this.props.outboundLogs) {
            return (<div className="OutboundResult">

                <div className="OutboundResult-log-details-container">
                    <table className="OutboundResult-log-details">
                        <thead>
                            <tr>
                                <th className="OutboundResult-date">Date</th>
                                <th className="OutboundResult-campaignid">CampaignID</th>
                                <th className="OutboundResult-recipient">Recipient Email</th>
                                <th className="OutboundResult-message">Message</th>
                                <th className="OutboundResult-response">ThreadID</th>
                                <th className="OutboundResult-draft">Create Draft</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getOutboundLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="OutboundResult-pagination">
                    <div className="OutboundResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="OutboundResult-pagination-buttongroup">
                        <button className="OutboundResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="OutboundResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.outboundLogs.logs && state.logs.outboundLogs.logs.length) {
        //showing 25 entries max per page
        return { outboundLogs: state.logs.outboundLogs.logs, maxPage: state.logs.outboundLogs.logs.length % 25 === 0 ? state.logs.outboundLogs.logs.length / 25 : Math.ceil(state.logs.outboundLogs.logs.length / 25) };
    }else{
        return{outboundLogs: null, maxPage: 1}
    }
};

export default connect(mapStateToProps)(OutboundResult);
